/******HOMEPAGE******/
/*PAGE*/
export default function Homepage() {
  /*DOM*/
  return (
    <div className="homepage ">
      <div className="mainText">
        <div className="mainLeft">
          <h2>Projet UNANÎMES : Université numérique avancée - DemoES</h2>
          <p>
            Nîmes Université, établissement jeune et dynamique, s’est{" "}
            <strong>
              {" "}
              pleinement engagée dans le déploiement des technologies numériques
            </strong>{" "}
            en adoptant une approche globale et structurée de l’ensemble de ses
            missions et infrastructures : pédagogie, fonctionnement
            administratif et organisation de la vie de campus. , en adoptant une
            approche globale au niveau de ses différentes missions et
            infrastructures : pédagogie, fonctionnement administratif,
            organisation de la vie de campus.
            <br />
            <br />
            <strong>
              Le programme numérique de l’établissement a permis d’installer
              durablement une culture du numérique partagée.
            </strong>
            Il a consisté à déployer des outils et des dispositifs facilitant le
            fonctionnement de l’université et soutenant la réussite des
            étudiants, depuis leur accueil jusqu’à l’obtention de leur diplôme,
            à tous les niveaux de leur parcours.
            <br />
            <br />
            <strong>
              Les réalisations menées sur plusieurs années, enrichies par de
              nombreux retours d’expérience, ont abouti à un programme cohérent,
              crédible et largement approprié par la communauté universitaire.{" "}
            </strong>{" "}
          </p>
        </div>

        <div className="mainRight">
          <img
            fetchpriority="high"
            src="/img/main.webp"
            className="logo"
            alt="illustration du projet UNANÎMES"
          />
        </div>
      </div>

      <div className="mainText mainText2">
        <div className="mainLeft">
          <p>
            Ce programme, désormais pleinement opérationnel, a été conçu pour
            favoriser l’accueil, le bien-être et la réussite des étudiants à
            travers des actions complémentaires et coordonnées autour de trois
            axes majeurs :{" "}
          </p>

          <p className="myList">
            un environnement numérique d’apprentissage structuré et performant ;
          </p>
           <br />
          <p className="myList">
            des innovations numériques mises au service des pratiques
            pédagogiques ;
          </p>
            <br />

          <p className="myList">
            le développement des compétences et des capacités numériques des
            étudiantes, étudiants et personnels.
          </p>
            <br />
          
          <p>
            <strong>
              Ce projet illustre l’engagement de Nîmes Université en faveur d’un
              numérique au service de la réussite, de l’innovation pédagogique
              et de la qualité de vie universitaire.
            </strong>
            <br />
            <br />
          </p>
        </div>
        <div className="mainRight">
          <img
            fetchpriority="high"
            src="/img/main2.webp"
            className="logo"
            alt="illustration du projet UNANÎMES"
          />
        </div>
      </div>
    </div>
  );
}
